import { apiClient } from './client';
import type {
  EntityLink,
  CreateEntityLinkInput,
  UpdateEntityLinkInput,
  EntityLinkQuery,
} from '@peles/shared';

export async function listEntityLinks(query: EntityLinkQuery): Promise<EntityLink[]> {
  const params: Record<string, string> = {};
  if (query.sourceEntityType) params.sourceEntityType = query.sourceEntityType;
  if (query.sourceEntityId) params.sourceEntityId = query.sourceEntityId;
  if (query.targetEntityType) params.targetEntityType = query.targetEntityType;
  if (query.targetEntityId) params.targetEntityId = query.targetEntityId;
  if (query.linkType) params.linkType = query.linkType;
  const { data } = await apiClient.get<EntityLink[]>('/entity-links', { params });
  return data;
}

export async function createEntityLink(input: CreateEntityLinkInput): Promise<EntityLink> {
  const { data } = await apiClient.post<EntityLink>('/entity-links', input);
  return data;
}

export async function updateEntityLink(
  id: string,
  updates: UpdateEntityLinkInput,
): Promise<EntityLink> {
  const { data } = await apiClient.patch<EntityLink>(`/entity-links/${id}`, updates);
  return data;
}

export async function deleteEntityLink(id: string): Promise<void> {
  await apiClient.delete(`/entity-links/${id}`);
}
